import React from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import { IconLogo } from '@wheely/ui-kit';

import s from './style.module.css';

const Header: React.FC = () => (
  <div className={cn(s.header)}>
    <div className={s.logoWrapper}>
      <Link to="/" className={s.logoLink}>
        <IconLogo className={s.icon} />
      </Link>
    </div>
  </div>
);

export { Header };
